// extracted by mini-css-extract-plugin
export default {"app":"app--2bf10b7d","loaderBody":"loaderBody--22709b53"};